import { forwardRef } from 'react';
import useStyles from './AppPaperContent.styles';
import { BoxProps, Box } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

type CustomAppPaperContentProps = {};

type AppPaperContentProps = Omit<BoxProps, keyof CustomAppPaperContentProps> & CustomAppPaperContentProps;

type AppPaperContentTypeMap<P = {}, D extends React.ElementType = 'div'> = {
  props: AppPaperContentProps & P;
  defaultComponent: D;
};
type AppPaperContentComponent = OverridableComponent<AppPaperContentTypeMap>;

const AppPaperContent = forwardRef((props: AppPaperContentProps, ref: React.ForwardedRef<any>) => {
  const { classes, cx, theme, css } = useStyles();
  const { children, className, sx, ...rest } = props;

  return (
    <Box ref={ref} {...rest} className={cx(classes.root, className, !!sx && css(theme.unstable_sx(sx!) as any))}>
      {children}
    </Box>
  );
}) as AppPaperContentComponent;

export default AppPaperContent;
